import { SbRichTextProps } from '../types';

export function blokHasManyNodes(blok: SbRichTextProps['blok']) {
  if (typeof blok === 'string') {
    return false;
  }

  return (
    (blok?.content?.length && blok?.content?.length > 1) ||
    blok?.attrs?.body?.length > 1
  );
}
